import React, { FC, useState } from "react";
import { useDropzone } from "react-dropzone";
import Button from "../atoms/Button";
import TextArea from "../atoms/TextArea";
import Label from "../atoms/Label";
import Deleteicon from "../../static/svg/Deleteicon";
import axios from "../../../config/axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { service } from "../../../services/AxiosServices";
import Spinner from "../atoms/Spinner";
import WindowHeightComponent from "../../Layouts/WindowHeight";
import AccessControl from "./AccessControl";
import fileAcceptTypes from "../../../utils/fileTypes";
interface Props {
  trainingSpace?: boolean;
  crewPrepare?: boolean;
  crewAnalyze?: boolean;
  spacePrepare?: boolean;
  spaceAnalyze?: boolean;
  crewSpace?: boolean;
  Id: string;
  phase?: number;
}
// Functional component for handling training document uploads
const TrainingCrew: FC<Props> = ({
  trainingSpace,
  crewPrepare,
  crewAnalyze,
  spaceAnalyze,
  spacePrepare,
  crewSpace,
  Id,
}) => {
  const [training, setTraining] = useState({
    crew: "",
    space_id: "",
    project_id: "",
    document: null as File | null,
    instruction: "",
    uploaded_by: "",
    entity_id: Id,
    entity_type:
      crewPrepare || crewAnalyze
        ? "Crew"
        : spacePrepare || spaceAnalyze
        ? "Knowledge hub"
        : "",
    status: "active",
    created_by: "",
  });

  const [files, setFiles] = useState<File[]>([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  // Handling file drop using react-dropzone
  const onDrop = (acceptedFiles: File[]) => {
    setFiles((prevFiles) => [...prevFiles, ...acceptedFiles]);
  };
  // Configuring file upload with accepted file types
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept:fileAcceptTypes,
    multiple: true,
  });

  const handleDeleteFile = (index: number) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };
  // Function to handle training document submission

  const navigateHandler = ()=>{
    if(trainingSpace){
      navigate(`/training/${Id}`, { state: { trainingSpace } });
    }
    else if(crewSpace){
      navigate(`/trained-crews/${Id}`);
    }
    else if(crewAnalyze){
      navigate(`/crew-analyzed-records/${Id}`)
    }
    else if(crewPrepare){
    navigate(`/crew-prepared-records/${Id}`)
    }
    else if(spaceAnalyze){
      navigate(`/space-analyzed-records/${Id}`)
    }
    else if(spacePrepare){
      navigate(`/space-prepared-records/${Id}`)
    }
  }
  const handleTraining = async () => {
    if (files.length === 0) {
      toast.warning("Please upload at least one file!", { autoClose: 2000 });
      return;
    }
    try {
      setLoading(true);
      const endPoint = trainingSpace
        ? "/api/ai-space-training"
        : crewAnalyze || spaceAnalyze
        ? "api/analyse-document/"
        : crewPrepare || spacePrepare
        ? "api/prepare-document/"
        : "/api/training";

      const updatedTraining = {
        ...training,
        space_id: trainingSpace ? Id : "",
      };
      const formData = new FormData();
      // Common fields for all endpoints
      formData.append("crew", Id);
      formData.append("project_id", String(localStorage.getItem("project_id")));
      formData.append("instruction", training.instruction);
      formData.append("uploaded_by", String(localStorage.getItem("user")));

      // Add specific fields based on the type of operation
      if (trainingSpace) {
        formData.append("space_id", Id);
      }

      // Add analyze and prepare specific fields
      if (crewAnalyze || crewPrepare || spaceAnalyze || spacePrepare) {
        formData.append("entity_id", Id);
        formData.append("entity_type", training.entity_type);
        formData.append("status", "active");
        formData.append("created_by", String(localStorage.getItem("user")));
        formData.append("category", "document");

        // Append files as "documents"
        files.forEach((file) => formData.append("file_upload", file));
      } else {
        // Default case, append files as "document"
        files.forEach((file) => formData.append("document", file));
      }
      // formData.forEach((value, key) => {
      //   console.log(key, value);
      // });

      const response = await service<void>(
        endPoint,
        "post",
        formData,
        "multipart/form-data"
      );
      console.log(response);
      const successMessage =
        crewAnalyze || spaceAnalyze
          ? "Document analysis initiated successfully"
          : crewPrepare || spacePrepare
          ? "Document preparation initiated successfully"
          : "Training completed successfully";

      toast.success(successMessage, { autoClose: 2000});
      navigateHandler()

      setTraining({
        crew: "",
        space_id: "",
        project_id: "",
        document: null,
        instruction: "",
        uploaded_by: "",
        entity_id: Id,
        entity_type: crewPrepare || crewAnalyze ? "Crew" : "",
        status: "active",
        created_by: "",
      });
      setFiles([]);
    } catch (err) {
      console.log(err);
      toast.warning("Something went wrong", { autoClose: 2000 });
    } finally {
      setLoading(false);
    }
  };

  return (
    <WindowHeightComponent className={""}>
      <div className="row m-0">
        <div className="col-9 m-auto mt-5">
          <div id="file_field" className="mb-3 text-center">
            {/* <Label htmlFor="file-upload" className="form-label LabelText mb-1">
              {trainingSpace
                ? "Upload"
                : "Upload"}
            </Label> */}
            <div {...getRootProps()} className="file-upload">
              <div className="file_button">Choose file</div>
              <div className="drag_space">
                <div className="drag_drop text-center">
                  or
                  <br />
                  Drop an attachment
                  <br />
                  (format: pdf, doc, jpg, png, xlsx)
                </div>
                <input
                  id="file-upload"
                  className="form-control DropAnAttachment"
                  {...getInputProps()}
                />
              </div>
            </div>
          </div>
          <div className="col-md-12">
            {files.map((file, index) => (
              <div key={index} className="d-flex align-items-center">
                <span className="text-primary">{file.name}</span>
                <span
                  className="cursor-pointer ms-3 d-block"
                  onClick={() => handleDeleteFile(index)}
                >
                  <Deleteicon />
                </span>
              </div>
            ))}
          </div>

          <div className="d-flex justify-content-end pt-3">
            <AccessControl
              requiredPermissions={[
                
                { permission:  crewAnalyze ? 'crew_analyze_documents' :spaceAnalyze ? 'analyze_documents' :
                  crewPrepare? 'prepare_document' : spacePrepare?'prepare_documents':
                  crewSpace  ? 'training': trainingSpace ? 'knowledge_hub' : '',
                   types: ["create"]
                  
                  },
              ]}
              renderNoAccess={<></>}
            >
              <Button onClick={handleTraining} className="btn SaveBtn">
                {loading ? (
                  <>
                    <div
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                    >
                      <span className="visually-hidden"></span>
                    </div>
                  </>
                ) : (
                  "Add"
                )}
              </Button>
            </AccessControl>
          </div>
        </div>
        {/* <div className="col-6">
            <Label htmlFor="instructions" className="form-label LabelText mb-1">
              Instructions
            </Label>
            <TextArea
              id="instructions"
              className="form-control rounded-0"
              value={training.instruction}
              onChange={(e) =>
                setTraining({ ...training, instruction: e.target.value })
              }
              rows={6}
              cols={50}
            />
          </div> */}
      </div>
    </WindowHeightComponent>
  );
};

export default TrainingCrew;
